import { CONTACT_EMAIL, SERVICE_NAME } from '@shared/constants/service'
import { AppHeader } from '@shared/ui/app-header'
import { Footer } from '@shared/ui/footer'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <div className="flex flex-1 flex-col">
      <AppHeader
        leading={<AppHeader.Back />}
        title="개인정보처리방침"
        variant="blur"
        divider="elevation"
      />

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-page-x py-6 pb-content-bottom">
        <div className="mx-auto max-w-lg space-y-8">
          <Section title="1. 수집하는 개인정보 항목">
            <p>
              {SERVICE_NAME}(이하 &quot;서비스&quot;)는 사주 분석을 위해 다음 정보를 수집합니다.
            </p>
            <div className="mt-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <h3 className="mb-2 typo-label font-semibold text-foreground">필수 수집 항목</h3>
              <ul className="list-disc space-y-1 pl-5 typo-label text-muted-foreground">
                <li>성별</li>
                <li>생년월일 (양력/음력)</li>
                <li>태어난 시간</li>
                <li>이름 (닉네임 가능)</li>
              </ul>
            </div>
            <div className="mt-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <h3 className="mb-2 typo-label font-semibold text-foreground">
                유료 결제 시 수집 항목
              </h3>
              <ul className="list-disc space-y-1 pl-5 typo-label text-muted-foreground">
                <li>결제 수단 정보 (결제 대행사를 통해 처리)</li>
                <li>결제 내역 (거래번호, 결제일시, 결제금액)</li>
              </ul>
            </div>
            <div className="mt-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <h3 className="mb-2 typo-label font-semibold text-foreground">자동 수집 항목</h3>
              <ul className="list-disc space-y-1 pl-5 typo-label text-muted-foreground">
                <li>기기 정보 (OS, 브라우저 종류)</li>
                <li>서비스 이용 기록, 접속 로그</li>
                <li>쿠키 및 서비스 이용 분석 정보</li>
              </ul>
            </div>
          </Section>

          <Section title="2. 개인정보의 수집 및 이용 목적">
            <ul className="list-disc space-y-2 pl-5">
              <li>사주 분석 서비스 제공 (AI 기반 결과 생성)</li>
              <li>서비스 품질 개선 및 통계 분석</li>
              <li>유료 서비스 결제 처리 및 환불</li>
              <li>서비스 관련 공지 및 고객 문의 대응</li>
            </ul>
          </Section>

          <Section title="3. AI 데이터 처리에 관한 사항">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스는 이용자가 입력한 정보를 AI 모델에 전달하여 사주 분석 결과를 생성합니다.
                이 과정에서 외부 AI API 제공사의 서버를 이용할 수 있습니다.
              </li>
              <li>
                이용자의 입력 정보는 분석 결과 생성 목적으로만 사용되며, AI 모델 학습(재훈련)에는
                사용하지 않습니다.
              </li>
              <li>
                서비스 품질 개선을 위해 비식별화된 통계 데이터를 활용할 수 있습니다.
              </li>
            </ol>
          </Section>

          <Section title="4. 개인정보의 보유 및 이용 기간">
            <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <ul className="space-y-3 typo-label">
                <li className="flex justify-between">
                  <span className="text-muted-foreground">사주 분석 입력 정보</span>
                  <span className="font-medium text-foreground">분석 완료 후 즉시 삭제</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-3">
                  <span className="text-muted-foreground">회원 계정 정보</span>
                  <span className="font-medium text-foreground">탈퇴 시 즉시 삭제</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-3">
                  <span className="text-muted-foreground">결제 기록</span>
                  <span className="font-medium text-foreground">5년 (전자상거래법)</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-3">
                  <span className="text-muted-foreground">접속 로그</span>
                  <span className="font-medium text-foreground">3개월 (통신비밀보호법)</span>
                </li>
              </ul>
            </div>
          </Section>

          <Section title="5. 개인정보의 제3자 제공">
            <p>
              서비스는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의
              경우에는 예외로 합니다.
            </p>
            <ol className="mt-2 list-decimal space-y-2 pl-5">
              <li>이용자가 사전에 동의한 경우</li>
              <li>법령에 따라 수사기관의 요청이 있는 경우</li>
              <li>통계 작성, 학술 연구 등의 목적으로 비식별화하여 제공하는 경우</li>
            </ol>
          </Section>

          <Section title="6. 개인정보 처리 위탁">
            <p>서비스는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁하고 있습니다.</p>
            <div className="mt-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <ul className="space-y-3 typo-label">
                <li className="flex justify-between">
                  <span className="text-muted-foreground">결제 처리</span>
                  <span className="font-medium text-foreground">토스페이먼츠</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-3">
                  <span className="text-muted-foreground">클라우드 인프라</span>
                  <span className="font-medium text-foreground">AWS (Amazon Web Services)</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-3">
                  <span className="text-muted-foreground">AI 분석 처리</span>
                  <span className="font-medium text-foreground">OpenAI</span>
                </li>
              </ul>
            </div>
          </Section>

          <Section title="7. 개인정보의 국외 이전">
            <p>
              서비스는 AI 기반 분석을 위해 이용자의 입력 정보를 국외 서버로 전송할 수 있습니다.
            </p>
            <div className="mt-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <ul className="space-y-2 typo-label">
                <li className="flex justify-between">
                  <span className="text-muted-foreground">이전 업체</span>
                  <span className="font-medium text-foreground">OpenAI (미국)</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-2">
                  <span className="text-muted-foreground">이전 항목</span>
                  <span className="font-medium text-foreground">사주 분석 입력 정보</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-2">
                  <span className="text-muted-foreground">이전 목적</span>
                  <span className="font-medium text-foreground">AI 사주 분석 결과 생성</span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-2">
                  <span className="text-muted-foreground">보유 기간</span>
                  <span className="font-medium text-foreground">분석 완료 후 즉시 삭제</span>
                </li>
              </ul>
            </div>
          </Section>

          <Section title="8. 쿠키 및 분석 도구">
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                서비스는 이용자 경험 개선 및 서비스 이용 통계 분석을 위해 쿠키(Cookie) 및 분석
                도구를 사용합니다.
              </li>
              <li>
                이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으며, 이 경우 일부 서비스
                이용에 제한이 있을 수 있습니다.
              </li>
            </ol>
          </Section>

          <Section title="9. 개인정보의 파기">
            <p>
              서비스는 개인정보 보유 기간이 만료되거나 처리 목적이 달성된 경우, 해당 정보를 지체
              없이 파기합니다. 전자적 파일은 복구 불가능한 방법으로 삭제하며, 종이 문서는 분쇄기를
              통해 파기합니다.
            </p>
          </Section>

          <Section title="10. 만 14세 미만 아동의 개인정보">
            <p>
              서비스는 만 14세 미만 아동의 개인정보를 수집하지 않습니다. 만 14세 미만임이 확인된
              경우 수집된 정보는 즉시 파기하며, 해당 계정의 서비스 이용을 제한합니다.
            </p>
          </Section>

          <Section title="11. 이용자의 권리 및 행사 방법">
            <p>이용자는 언제든지 다음의 권리를 행사할 수 있습니다.</p>
            <ul className="mt-2 list-disc space-y-2 pl-5">
              <li>개인정보 열람, 정정, 삭제 요청</li>
              <li>개인정보 처리 정지 요청</li>
              <li>동의 철회</li>
            </ul>
            <p className="mt-3">
              위 요청은 서비스 내 고객센터 또는 이메일({CONTACT_EMAIL})을 통해 접수할 수 있으며,
              접수 후 10일 이내에 처리합니다.
            </p>
          </Section>

          <Section title="12. 개인정보의 안전성 확보 조치">
            <ul className="list-disc space-y-2 pl-5">
              <li>개인정보의 암호화 전송 (SSL/TLS)</li>
              <li>접근 권한 관리 및 접근 통제</li>
              <li>개인정보 처리 시스템의 접속 기록 보관</li>
              <li>보안 프로그램 설치 및 주기적 갱신</li>
            </ul>
          </Section>

          <Section title="13. 개인정보 보호책임자">
            <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4">
              <ul className="space-y-2 typo-label">
                <li className="flex justify-between">
                  <span className="text-muted-foreground">담당자</span>
                  <span className="font-medium text-foreground">
                    {SERVICE_NAME} 개인정보 보호팀
                  </span>
                </li>
                <li className="flex justify-between border-t border-white/[0.06] pt-2">
                  <span className="text-muted-foreground">이메일</span>
                  <span className="font-medium text-foreground">{CONTACT_EMAIL}</span>
                </li>
              </ul>
            </div>
          </Section>

          <Section title="14. 방침의 변경">
            <p>
              이 개인정보처리방침은 관련 법령 및 내부 정책 변경에 따라 수정될 수 있으며, 변경 시
              서비스 내 공지를 통해 안내합니다.
            </p>
          </Section>

          <footer className="border-t border-white/[0.06] pt-6 typo-footnote text-muted-foreground">
            <p>시행일: 2026년 3월 31일</p>
            <p className="mt-1">{SERVICE_NAME} 운영팀</p>
          </footer>
        </div>
      </div>

      <Footer />
    </div>
  )
}

function Section({
  title,
  children,
}: {
  readonly title: string
  readonly children: React.ReactNode
}) {
  return (
    <section>
      <h2 className="mb-3 typo-body font-bold text-foreground">{title}</h2>
      <div className="space-y-2 typo-label text-muted-foreground">{children}</div>
    </section>
  )
}
